import { render, staticRenderFns } from "./bulma_actions.vue?vue&type=template&id=3097fcdb&scoped=true&lang=html"
import script from "./bulma_actions.vue?vue&type=script&lang=js"
export * from "./bulma_actions.vue?vue&type=script&lang=js"
import style0 from "./bulma_actions.vue?vue&type=style&index=0&id=3097fcdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3097fcdb",
  null
  
)

export default component.exports